<template>
	<div class="form-group clear-left">
		<label style="display: block; clear: left">{{
			competencytest.Code + ': ' + competencytest.Name
			}}</label>
		<div class="btn-group">
			<button
				class="btn"
				v-bind:class="{
					'btn-on': competencytest.CurrentHasPassed === 1,
                    'btn-on-good': !this.$config.getValue('testsoftmarking'),
					'btn-off': competencytest.CurrentHasPassed !== 1
				}"
				@click="togglePassed(1)"
				:disabled="!canMark"
			>
				{{ getDichotomy('true') }}
			</button>
			<button
				class="btn"
				v-bind:class="{
					'btn-on': competencytest.CurrentHasPassed === 0,
                    'btn-on-bad': !this.$config.getValue('testsoftmarking'),
					'btn-off': competencytest.CurrentHasPassed !== 0
				}"
				v-on:click="togglePassed(0)"
				:disabled="!canMark"
			>
				{{ getDichotomy('false') }}
			</button>
		</div>

		<button
			v-if="canMark && competencytest.form"
			class="btn btn-light ml-2"
			@click="toggleMarking"
		>
			{{ $t('mark') }}
		</button>

		<button
			v-if="!canMark && competencytest.form"
			class="btn btn-light ml-2"
			@click="toggleMarking"
		>
			{{ $t('details') }}
		</button>
	</div>
</template>

<script>
export default {
	name: "treatmentsessionformelements",
	props: {
		treatmentsession: Object,
		competencytest: Object,
		canMark: Boolean
	},
	computed: {
	},
	methods: {
		togglePassed(passed) {
			if(this.competencytest.form){
				this.toggleMarking();
			} else {
				if (this.competencytest.CurrentHasPassed !== passed) {
					this.competencytest.CurrentHasPassed = passed;
				} else {
					this.competencytest.CurrentHasPassed = -1;
				}
			}
		},
		toggleMarking() {
			this.$emit('markCompetencyTest' , this.competencytest);
			//this.competencytestmarking = this.competencytest;
			/*
			this.$store.state.treatmentSessionCompetencyTestMarking.showModal = !this.$store.state.treatmentSessionCompetencyTestMarking.showModal;
			this.$store.state.treatmentSessionCompetencyTestMarking.test = this.competencytest;
			*/
		},
		getDichotomy(type){
			if(this.$config.getValue('dichotomies') && this.competencytest.dichotomy_id in this.$config.getValue('dichotomies')){
				return this.$config.getValue('dichotomies')[this.competencytest.dichotomy_id][type]
			}
			if(type == 'true'){
				return this.$t('pass');
			}
			if(type == 'false'){
				return this.$t('fail');
			}
		}
	}
};
</script>
